<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <br>
        <!-- snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- overlay -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin -->
        <template v-if="cay != null">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Login Details Report </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-row>
                        <v-col sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded v-model="cay" return-object item-text="ay"
                                :items="ay_list" label="Select AY" outlined persistent-hint hint="Please Select AY" />
                        </v-col>
                        <v-col sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded item-text="display_name" return-object
                                v-model="csem" :items="sem_list" label="Select Semester/Term" outlined persistent-hint
                                hint="Please Select Semester/Term" />
                        </v-col>
                        <v-col sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded v-model="ut" :items="ut_list"
                                label="Select user type" outlined persistent-hint hint="Please Select user type" />
                        </v-col>
                        <v-col sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded v-model="report" :items="report_list"
                                label="Select report" outlined persistent-hint hint="Please Select report" />
                        </v-col>
                    </v-row>
                    <v-row allign="center" justify="center">
                        <v-col sm="3" md="3">
                            <v-btn color="info" @click="loginDetails">Get Details</v-btn>
                        </v-col>
                    </v-row>
                     Start Date: {{ formatDate(csem.start_date) }} || End Date: {{ formatDate(csem.end_date) }} <br>
                    Note: Data will be accurate only for current ay & semester/term
                    <!-- {{ cay }} || {{ csem }} || {{ ut }} || {{ report }} -->
                </v-card-text>
            </v-card>
            <v-card v-if="parent_login_details.length != 0">
                <v-btn class="ma-2 no-display " rounded color="success" outlined
                    @click="fnExcelReportParent('my-table-id', 'Login Details')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
                <v-card-title>
                    Report:{{ report }} || User Type: {{ ut }}
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table id="my-table-id" :headers="parent_login_headers" :items="parent_login_details"
                    :search="search"></v-data-table>
            </v-card>
            <v-card v-if="emp_login_details.length != 0">
                <v-btn class="ma-2 no-display " rounded color="success" outlined
                    @click="fnExcelReportEmployee('my-table-id1', 'Employee Login Details')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
                <v-card-title>
                    Report:{{ report }}
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table id="my-table-id1" :headers="emp_login_headers" :items="emp_login_details"
                    :search="search"></v-data-table>
            </v-card>
        </template>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

    data: () => ({
        snackbar_msg: "",
        color: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        snackbar: false,
        overlay: false,
        ///////////////////////////////////////////////
        ay_list: [],
        sem_list: [],
        cay: null,
        csem: null,
        ut: "Parent",
        ut_list: ["Parent", "Student", "Employee"],
        report_list: ["Logged-In", "Not Logged-In"],
        report: "Not Logged-In",
        ////////////////////////////
        parent_login_details: [],
        emp_login_details: [],
        login_usernames_from_logs: [],
        search: '',
        parent_login_headers: [
            {
                value: 'stud_name',
                text: 'Name',
            },
            { value: 'stud_regno', text: 'PRN' },
            { value: 'stud_std_div', text: 'Std:Div' },
            { value: 'stud_rollno', text: 'Roll No' },
            { value: 'stud_parent_login', text: 'Parent Login' },
            { value: 'stud_parent_contact', text: 'Parent Contact' },
        ],
        emp_login_headers: [
            {
                value: 'emp_name',
                text: 'Name',
            },
            { value: 'emp_code', text: 'Code' },
            { value: 'emp_login', text: 'Login Id' },
            { value: 'emp_contact', text: 'Contact' },
        ],
    }),
    methods: {
        formatDate(dateStr) {
      if (!dateStr) return '';
      // Parse the input date (assuming it's in UTC from frontend)
      const date = new Date(dateStr);
      // Add 5 hours and 30 minutes to convert back to IST (backend time)
      date.setUTCHours(date.getUTCHours() + 5);
      date.setUTCMinutes(date.getUTCMinutes() + 30);
      // Format to match backend: "YYYY-MM-DD HH:MM:SS.0"
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      const hours = String(date.getUTCHours()).padStart(2, '0');
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');
      const seconds = String(date.getUTCSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.0`;
    },
        fnExcelReportParent(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
                <th>Name</th>
                <th>PRN</th>
                <th>Std:Div</th>
                <th>Roll No</th>
                <th>Parent Login</th>
                <th>Parent Contact</th>
            </tr>`;
            this.parent_login_details.forEach((s, index) => {
            tab_text += `
             <tr>
                <td>${s.stud_name}</td>
                <td>${s.stud_regno}</td>
                <td>${s.stud_std_div}</td>
                <td>${s.stud_rollno}</td>
                <td>${s.stud_parent_login}</td>
                <td>${s.stud_parent_contact}</td>
            </tr>`;
         });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
         // For IE
            window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
                }
        },
        fnExcelReportEmployee(id, name) {
        let tab_text = `<table border='1px'>
        <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Login Id</th>
            <th>Contact</th>
        </tr>`;

        this.emp_login_details.forEach((s, index) => {
            tab_text += `
            <tr>
                <td>${s.emp_name}</td>
                <td>${s.emp_code}</td>
                <td>${s.emp_login}</td>
                <td>${s.emp_contact}</td>
            </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // For IE
            window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        ///////////
        async init() {
            this.overlay = true;
            try {
                const res = await axios.post("/commonAPI/getAYSem")
                if (res.data.flag == "YES") {
                    this.ay_list = res.data.ay_list
                    this.cay = res.data.cay
                    this.sem_list = res.data.sem_list
                    this.csem = this.sem_list[0]
                    this.showSnackbar("green", res.data.snackbar);
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }

        },
        
async loginDetails() {
    this.parent_login_details = [];
    this.emp_login_details = [];
    this.login_usernames_from_logs = [];
    const formdata = {
        cay: this.cay.id,
        csem: this.csem.id,
        ut: this.ut,
        report: this.report
    }
    this.overlay = true;
    try {
        const res = await axios.post("/login/loginDetails", formdata)
        if (res.data.flag == "YES") {
            this.login_usernames_from_logs = res.data.login_usernames_from_logs || [];

            if (this.ut == "Parent" || this.ut == "Student") {
                // Combine login_list and logs users
                const loginList = res.data.parent_login_details || [];
                const logsUsers = res.data.login_user_details_from_logs || [];

                // Convert logs users into parent_login_details format
                const logsList = logsUsers.map(u => ({
                    ldid: null,
                    stud_name: u.full_name || u.username, // or derive from User fields
                    stud_regno: u.registration_number || '',
                    stud_rollno: '',
                    stud_std_div: '',
                    stud_parent_login: u.username,
                    stud_parent_contact: u.mobile_no || '',
                }));

                // Merge and mark login status
                const combinedList = [...loginList, ...logsList].map(item => ({
                    ...item,
                    login_status: this.login_usernames_from_logs.includes(item.stud_parent_login) ? 'Logged In' : 'Not Logged In'
                }));

                this.parent_login_details = combinedList;

            } else if (this.ut == "Employee") {
                const loginList = res.data.emp_login_details || [];
                const logsUsers = res.data.login_user_details_from_logs || [];

                const logsList = logsUsers.map(u => ({
                    instid: null,
                    emp_name: u.full_name || u.username,
                    emp_code: u.employee_code || '',
                    emp_login: u.username,
                    emp_contact: u.mobile_no || ''
                }));

                const combinedList = [...loginList, ...logsList].map(item => ({
                    ...item,
                    login_status: this.login_usernames_from_logs.includes(item.emp_login) ? 'Logged In' : 'Not Logged In'
                }));

                this.emp_login_details = combinedList;
            }

            this.showSnackbar("green", res.data.snackbar);
        } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        this.overlay = false;
    } catch (err) {
        console.log("err", err)
        this.onerror(err);
        this.overlay = false;
    } finally {
        console.log("bye...")
        this.overlay = false;
    }
},

    },
    mounted() {
        this.init()
    },

};
</script>